/* eslint-disable camelcase */
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { AppConfig } from '../../../AppConfig';
import { Controller } from '../../../common/Controller';

import moment from 'moment-timezone'
import { Grid } from '@material-ui/core';
import { CommonStyles } from '../../../styles/Styles';
import { StatCard } from '../../../common/components/StatCard';
import { Link } from 'react-router-dom';
import { AppHelper } from '../../../helpers/AppHelper';

export class CrmInbox extends BaseEntityPage {

  constructor(props, options) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = options.pageTitle || Helper.getString('crm-inbox')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.inboxId = this.props.match.params.inboxId
    this.staffUserId = Controller.get().getUserId()
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('crm-inboxes'), to: this.baseRoute() + '/crm-inboxes'},
    ]
    this.toFetch = [
      { key: 'crminbox', ms: this.ms, method: 'GET', paths: ['crminboxs', this.inboxId], queryParams: { orgId: this.orgId } },
      { key: 'inboxenrolmentdata', ms: this.ms, method: 'GET', paths: ['miscs', 'get-inbox-enrolment-data'], queryParams: { orgId: this.orgId, inboxId: this.inboxId } },
    ]
    this.apiData = {
      orgId: this.orgId,
      userId: this.staffUserId,
    }
    this.pageKey = 'crm-inbox'
    this.noAdd = true
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Contact: (current) => <Link to={this.baseRoute() + '/crm-contacts/' + current.userId} key={'viewcontact-' + current.userId}>{current._contactName || current._contactEmail}</Link>,
      Campaign: (current) => <Link to={this.baseRoute() + '/campaigns/sequences/' + current.campaignId} key={'viewcampaign-' + current.campaignId}>{current._campaignName}</Link>,
      //'Complete by': (current) => current._completeBy === -1 ? 'Unknown' : Helper.formatTimestamp(Helper.getNextHourTs(current._completeBy)),
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.headerActions = [
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      }
    ]
  }

  onFetchSuccess(results) {
    this.crmInbox = this.getResult(results, 'crminbox')
    this.inboxEnrolments = this.getResult(results, 'inboxenrolmentdata').map(e => {
      const stepSlots = Object.values(e._slots ? e._slots.steps || {} : {})
      const _completeBy = stepSlots.length > 0 && !stepSlots.includes(-1) ? Math.max(...stepSlots) : -1
      return {
        ...e,
        _completeBy,
      }
    }).sort((a, b) => b._completeBy - a._completeBy)
    const pendingOutreaches = this.inboxEnrolments.filter(ie => ie.stepsExecuted.length === 0).length
    const pendingEmails = this.inboxEnrolments.reduce((p, c) => p + ((c.steps || []).length - (c.stepsExecuted || []).length), 0)
    if (this.breadCrumbs.length === 2) { this.breadCrumbs.push({title: this.crmInbox.email }) }
    this.setState({
      items: this.inboxEnrolments,
      stats: {
        pendingOutreaches,
        pendingEmails,
        outreachedToday: this.crmInbox.outreachLimitIntervalCount,
      }
    })
  }

  onActions(current) {
    return []
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) { return '' }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  renderAboveTable() {
    if (!Array.isArray(this.state.items)) return
    const maxOutreachesPerDay = Number.parseInt(AppHelper.getSetting(this.orgId, 'MAX_INBOX_OUTREACH_LIMIT_PER_INTERVAL'))
    const tiles1 = [
      { title: 'Live Enrolments', value: Math.round(this.state.items.length) },
      { title: 'Outreach Started', value: Math.round(this.state.items.length - this.state.stats.pendingOutreaches) },
      { title: 'Outreach Pending', value: Math.round(this.state.stats.pendingOutreaches) },
      { title: 'Emails Pending', value: Math.round(this.state.stats.pendingEmails) },
    ]
    const tiles2 = [
      { title: 'Outreached Today', value: Math.round(this.state.stats.outreachedToday) },
      { title: 'Outreaches Remaining', value: Math.round(maxOutreachesPerDay - this.state.stats.outreachedToday) },
    ]
    return (
      <div className={css(Styles.statsContainer)}>
        {this.state.items.length > 0 && <div className={css(Styles.statsSectionContainer)}>
          <p className={css(Styles.statsSectionTitle)}>Live Enrolments</p>
            <Grid container spacing={2} className={css(CommonStyles.statContainer)}>
            {tiles1.map((tile, index) => (
              <StatCard
                // sm={5}
                key={tile.title}
                text={tile.value}
                subText={tile.title.toLocaleUpperCase()}
                cardIndex={index}
              />
            ))}
          </Grid>
        </div>}
        <div className={css(Styles.statsSectionContainer)}>
          <p className={css(Styles.statsSectionTitle)}>Daily Stats</p>
          <Grid container spacing={2} className={css(CommonStyles.statContainer)}>
            {tiles2.map((tile, index) => (
              <StatCard
                // sm={5}
                key={tile.title}
                text={tile.value}
                subText={tile.title.toLocaleUpperCase()}
                cardIndex={index}
              />
            ))}
          </Grid>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 14
  },
  line2: {
    fontSize: 12,
    color: 'grey'
  },
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '16px'
  },
  statsSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  statsSectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
})